(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-catalog"]) return;
  try {
    
if (!customElements.get('eg-mega-menu')) {
  customElements.define('eg-mega-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.panel = this.querySelector('.egm-panel');
      this.overlay = this.querySelector('.egm-overlay');
      this.rootlist = this.querySelector('.egm-rootlist');
      this.roots = Array.from(this.querySelectorAll('[data-eg-root]'));
      this.rootLinks = this.roots.map(root => root.querySelector('.egm-root-link'));
      this.rootButtons = this.roots.map(root => root.querySelector('[data-eg-root-expand]'));
      this.departments = Array.from(this.querySelectorAll('[data-eg-department]'));
      this.back = this.querySelector('[data-eg-menu-back]');
      this.mobileTitle = this.querySelector('[data-eg-mobile-title]');
      this.rootLabel = this.mobileTitle.textContent;
      this.venueView = this.querySelector('[data-eg-view="venues"]');
      this.venueLabel = this.venueView?.dataset.venueLabel || '';
      this.venueButtons = Array.from(this.querySelectorAll('[data-eg-venue]'));
      this.venueDetails = Array.from(this.querySelectorAll('[data-eg-venue-detail]'));
      this.currentView = 'catalog';
      this.activeVenue = null;
      this.mobile = matchMedia('(max-width:900px)');
      this.activeIndex = 0;
      this.opened = false;
      const listen = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.abort.signal });
      this.toggles = Array.from(document.querySelectorAll('[data-eg-menu-toggle]'));
      this.viewToggles = Array.from(this.querySelectorAll('[data-eg-view-toggle]'));
      listen(document, 'click', event => {
        const button = event.target.closest('[data-eg-menu-toggle]');
        if (button) this.toggleView('catalog', button);
      });
      this.viewToggles.forEach(button => listen(button, 'click', () => this.toggleView(button.dataset.egViewToggle, button)));
      this.querySelectorAll('[data-eg-view-select]').forEach(button => listen(button, 'click', () => this.setView(button.dataset.egViewSelect, true)));
      this.venueButtons.forEach((button, index) => listen(button, 'click', () => this.selectVenue(index)));
      this.querySelectorAll('[data-eg-venue-back]').forEach(button => listen(button, 'click', () => this.resetVenues(true)));
      this.querySelectorAll('[data-eg-menu-close]').forEach(button => listen(button, 'click', () => this.close()));
      listen(this.back, 'click', () => this.goBack());
      this.roots.forEach((root, index) => {
        const button = this.rootButtons[index];
        listen(button, 'click', () => { this.select(index); if (this.mobile.matches) { this.setLevel('department'); this.back.focus(); } });
        listen(root, 'pointerenter', event => {
          if (this.mobile.matches || event.pointerType !== 'mouse' || !this.opened) return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => this.select(index), 180);
        });
        listen(root, 'pointerleave', () => clearTimeout(this.hoverTimer));
        listen(root, 'keydown', event => {
          if (this.mobile.matches) return;
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % this.roots.length;
          else if (event.key === 'ArrowUp') next = (index + this.roots.length - 1) % this.roots.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.roots.length - 1;
          else if (event.key === 'ArrowRight') { event.preventDefault(); this.select(index); this.departments[index].querySelector('a')?.focus(); return; }
          else return;
          event.preventDefault(); this.select(next); this.rootLinks[next].focus();
        });
      });
      this.querySelectorAll('[data-eg-group-open]').forEach(button => listen(button, 'click', () => {
        this.activeGroup = button.closest('[data-eg-group]');
        this.activeGroup.querySelectorAll('.egm-more').forEach(details => { details.open = true; });
        this.activeGroup.setAttribute('data-mobile-active', ''); button.setAttribute('aria-expanded', 'true');
        this.setLevel('group'); this.back.focus();
      }));
      listen(this, 'click', event => { if (event.target.closest('a[href]')) this.close(false); });
      listen(document, 'pointerdown', event => { if (this.opened && !this.contains(event.target) && !event.target.closest('[data-eg-menu-toggle]')) this.close(false); });
      listen(document, 'keydown', event => {
        if (!this.opened) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key === 'ArrowLeft' && !this.mobile.matches && event.target.closest('.egm-content')) { event.preventDefault(); this.rootLinks[this.activeIndex]?.focus(); return; }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.panel.querySelectorAll('button:not([tabindex="-1"]),a[href],summary')).filter(el => el.getClientRects().length > 0 && !el.disabled && !el.closest('details:not([open])>div'));
        if (!this.mobile.matches) focusable.unshift(...[...this.toggles,...this.viewToggles,...this.querySelectorAll('.egm-offer-trigger')].filter(el => el.getClientRects().length > 0));
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first?.focus(); }
      });
      listen(window, 'resize', () => { if (this.opened) this.schedulePosition(); });
      listen(window, 'pageshow', event => { if (event.persisted) this.close(false); });
      listen(this.mobile, 'change', () => { this.close(false); this.configure(); });
      this.configure();
    }
    toggleView(view, button) {
      if (!this.opened) this.open(button, view);
      else if (this.currentView === view) this.close();
      else { this.opener = button; this.setView(view, true); }
    }
    updateTriggers() {
      this.toggles = Array.from(document.querySelectorAll('[data-eg-menu-toggle]'));
      this.toggles.forEach(toggle => toggle.setAttribute('aria-expanded', String(this.opened && (this.currentView === 'catalog' || toggle.classList.contains('mobile-menu')))));
      this.viewToggles.forEach(toggle => toggle.setAttribute('aria-expanded', String(this.opened && this.currentView === toggle.dataset.egViewToggle)));
      this.querySelectorAll('[data-eg-view-select]').forEach(button => { if (button.closest('.egm-mobile-tabs')) button.setAttribute('aria-pressed', String(this.currentView === button.dataset.egViewSelect)); });
    }
    clearGroup() {
      this.activeGroup?.removeAttribute('data-mobile-active'); this.activeGroup = null;
      this.querySelectorAll('[data-eg-group-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    }
    setView(view, focus = false) {
      this.currentView = view === 'venues' && this.venueView ? 'venues' : 'catalog';
      this.dataset.view = this.currentView;
      this.querySelectorAll('[data-eg-view]').forEach(panel => { panel.hidden = panel.dataset.egView !== this.currentView; });
      this.clearGroup(); this.resetVenues(false); this.setLevel('root'); this.updateTriggers();
      this.panel.setAttribute('aria-label', this.currentView === 'catalog' ? this.rootLabel : this.venueLabel);
      if (this.mobile.matches) this.rootButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (focus) {
        if (this.currentView === 'venues') this.venueButtons[0]?.focus();
        else this.rootLinks[this.mobile.matches ? 0 : this.activeIndex]?.focus();
      }
    }
    selectVenue(index) {
      this.activeVenue = index;
      this.venueView.querySelector('[data-eg-venue-list]').hidden = true;
      this.venueButtons.forEach((button, i) => button.setAttribute('aria-expanded', String(i === index)));
      this.venueDetails.forEach((panel, i) => { panel.hidden = i !== index; });
      this.venueView.querySelector('[data-eg-venue-title]').textContent = this.venueButtons[index].dataset.venueName;
      this.venueView.querySelector('[data-eg-venue-intro]').textContent = this.venueView.dataset.venueDetailIntro;
      this.venueView.querySelector('[data-eg-venue-back]').hidden = false;
      this.venueView.querySelector('.egm-venue-scroll').scrollTop = 0;
      this.setLevel('venue');
      if (this.mobile.matches) this.back.focus(); else this.venueView.querySelector('[data-eg-venue-back]').focus();
    }
    resetVenues(focus) {
      if (!this.venueView) return;
      const previous = this.activeVenue;
      this.activeVenue = null;
      this.venueView.querySelector('[data-eg-venue-list]').hidden = false;
      this.venueButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.venueDetails.forEach(panel => { panel.hidden = true; });
      this.venueView.querySelector('[data-eg-venue-title]').textContent = this.venueLabel;
      this.venueView.querySelector('[data-eg-venue-intro]').textContent = this.venueView.dataset.venueIntro;
      this.venueView.querySelector('[data-eg-venue-back]').hidden = true;
      this.setLevel('root');
      if (focus) this.venueButtons[previous || 0]?.focus();
    }
    configure() {
      const mobile = this.mobile.matches;
      this.rootlist.setAttribute('role', 'navigation');
      this.rootButtons.forEach((button, index) => button.setAttribute('aria-expanded', String(!mobile && index === this.activeIndex)));
      this.departments.forEach(panel => panel.setAttribute('role', 'group'));
      this.panel.setAttribute('role', mobile ? 'dialog' : 'region');
      if (mobile) this.panel.setAttribute('aria-modal', 'true'); else this.panel.removeAttribute('aria-modal');
      this.querySelectorAll('.egm-more').forEach(details => { details.open = mobile; });
    }
    select(index) {
      clearTimeout(this.hoverTimer); this.activeIndex = index;
      this.roots.forEach((root, i) => root.dataset.active = String(i === index));
      this.rootButtons.forEach((button, i) => button.setAttribute('aria-expanded', String(i === index)));

      this.departments.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    setLevel(level) {
      this.dataset.level = level; this.back.hidden = level === 'root';
      if (this.currentView === 'venues') {
        this.mobileTitle.textContent = level === 'venue' ? this.venueButtons[this.activeVenue].dataset.venueName : this.venueLabel;
        this.back.querySelector('[data-eg-back-label]').textContent = this.venueLabel;
        return;
      }
      const title = this.rootLinks[this.activeIndex]?.textContent.trim() || this.rootLabel;
      this.mobileTitle.textContent = level === 'root' ? this.rootLabel : level === 'group' ? this.activeGroup.querySelector('.egm-group-title').textContent.trim() : title;
      this.back.querySelector('[data-eg-back-label]').textContent = level === 'group' ? title : this.rootLabel;
      const scroll = this.departments[this.activeIndex]?.querySelector('.egm-scroll'); if (scroll) scroll.scrollTop = 0;
    }
    goBack() {
      if (this.currentView === 'venues') { this.resetVenues(true); return; }
      if (this.dataset.level === 'group') {
        const button = this.activeGroup.querySelector('[data-eg-group-open]');
        this.activeGroup.removeAttribute('data-mobile-active'); button.setAttribute('aria-expanded', 'false');
        this.activeGroup = null; this.setLevel('department'); button.focus();
      } else {
        this.setLevel('root'); this.rootButtons.forEach(button => button.setAttribute('aria-expanded', 'false')); this.rootLinks[this.activeIndex]?.focus();
      }
    }
    schedulePosition() { cancelAnimationFrame(this.positionFrame); this.positionFrame = requestAnimationFrame(() => this.position()); }
    position() {
      if (this.mobile.matches) return;
      const toolbar = this.querySelector('.egm-toolbar-inner'), rect = toolbar.getBoundingClientRect(), style = getComputedStyle(toolbar);
      const start = parseFloat(style.paddingLeft), end = parseFloat(style.paddingRight);
      this.style.setProperty('--egm-top', Math.max(0, rect.bottom) + 'px');
      this.style.setProperty('--egm-left', rect.left + start + 'px'); this.style.setProperty('--egm-width', rect.width - start - end + 'px');
    }
    open(button, view = 'catalog') {
      if (this.opened) return;
      this.opener = button; this.opened = true; this.configure(); this.position();
      this.panel.hidden = false; this.overlay.hidden = false;
      this.previousOverflow = document.body.style.overflow; this.previousPadding = document.body.style.paddingRight;
      const gutter = window.innerWidth - document.documentElement.clientWidth;
      if (gutter) document.body.style.paddingRight = parseFloat(getComputedStyle(document.body).paddingRight) + gutter + 'px';
      document.body.style.overflow = 'hidden';
      this.inertElements = Array.from(document.querySelectorAll(this.mobile.matches ? '#MainContent,.store-footer,.store-header,.eg-mobile-dock' : '#MainContent,.store-footer')).map(element => ({ element, wasInert: element.inert }));
      this.inertElements.forEach(({ element }) => { element.inert = true; });
      this.select(this.activeIndex); this.setView(view, true);
      this.schedulePosition();
    }
    close(returnFocus = true) {
      if (!this.opened) return;
      clearTimeout(this.hoverTimer); cancelAnimationFrame(this.positionFrame); this.opened = false;
      this.panel.hidden = true; this.overlay.hidden = true;
      this.updateTriggers();
      document.body.style.overflow = this.previousOverflow; document.body.style.paddingRight = this.previousPadding;
      this.inertElements?.forEach(({ element, wasInert }) => { element.inert = wasInert; });
      this.clearGroup(); this.resetVenues(false);
      this.setLevel('root'); if (returnFocus) this.opener?.focus();
    }
    disconnectedCallback() { this.close(false); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-product"]) return;
  try {
    

(() => {
  function init(root) {
    if (!root || root.dataset.pdpReady) return;
    root.dataset.pdpReady = 'true';
    const data = JSON.parse(root.querySelector('[data-pdp-variant-data]').textContent);
    const select = root.querySelector('[data-pdp-variant]');
    const form = root.querySelector('[data-add-form]');
    const input = form.querySelector('[name="quantity"]');
    const button = root.querySelector('[data-pdp-submit]');
    const sticky = root.querySelector('[data-pdp-sticky]');
    const stickyButton = root.querySelector('[data-pdp-sticky-submit]');
    const image = root.querySelector('.pdp-main-image');
    const zoom = root.querySelector('[data-pdp-zoom]');
    const thumbnails = [...root.querySelectorAll('[data-pdp-thumbnail]')];
    const dialog = root.querySelector('[data-pdp-lightbox]');
    const productTitle = root.dataset.productTitle;
    const productUrl = root.dataset.productUrl.split('?')[0];
    const factIcons = root.querySelector('[data-pdp-fact-icons]').content;
    let noticeTimer;
    function notice(text) {
      clearTimeout(noticeTimer);
      root.querySelector('[data-pdp-notice]').textContent = text;
      noticeTimer = setTimeout(() => { root.querySelector('[data-pdp-notice]').textContent = ''; }, 3000);
    }
    function quantity() {
      const minimum = Number(input.min) || 1, step = Number(input.step) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      let value = Number(input.value) || minimum;
      value = Math.min(maximum, Math.max(minimum, minimum + Math.round((value - minimum) / step) * step));
      input.value = value;
      root.querySelector('[data-pdp-quantity="-1"]').disabled = value <= minimum;
      root.querySelector('[data-pdp-quantity="1"]').disabled = value >= maximum;
    }
    root.querySelectorAll('[data-pdp-quantity]').forEach(control => control.addEventListener('click', () => {
      input.value = (Number(input.value) || Number(input.min) || 1) + Number(control.dataset.pdpQuantity) * (Number(input.step) || 1);
      quantity();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    input.addEventListener('change', quantity);
    quantity();
    function showImage(src, full, alt, id) {
      if (!image || !src) return;
      image.removeAttribute('srcset');
      image.src = src;
      image.alt = alt || '';
      zoom.href = full || src;
      thumbnails.forEach(thumb => {
        const selected = thumb.dataset.imageId === String(id);
        thumb.setAttribute('aria-current', String(selected));
        if (selected) root.querySelector('[data-pdp-image-number]').textContent = thumb.dataset.imageNumber;
      });
    }
    thumbnails.forEach(thumb => thumb.addEventListener('click', event => {
      event.preventDefault();
      showImage(thumb.href, thumb.dataset.full, thumb.querySelector('img').alt, thumb.dataset.imageId);
    }));
    const selectedThumb = thumbnails.find(t => t.getAttribute('aria-current') === 'true');
    if (selectedThumb) root.querySelector('[data-pdp-image-number]').textContent = selectedThumb.dataset.imageNumber;
    zoom?.addEventListener('click', event => {
      if (!dialog?.showModal) return;
      event.preventDefault();
      const enlarged = dialog.querySelector('img');
      enlarged.src = zoom.href;
      enlarged.alt = image.alt;
      dialog.showModal();
    });
    root.querySelector('[data-pdp-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    root.querySelector('[data-pdp-copy]')?.addEventListener('click', async () => {
      const sku = root.querySelector('[data-pdp-sku]').textContent;
      try { await navigator.clipboard.writeText(sku); notice(root.dataset.copied); }
      catch { notice(sku); }
    });
    const tabs = [...root.querySelectorAll('[data-pdp-tab]')];
    const panels = [...root.querySelectorAll('[data-pdp-panel]')];
    root.querySelector('.pdp-tabs').setAttribute('role', 'tablist');
    function showPanel(name, focus = false) {
      tabs.forEach(tab => {
        const active = tab.dataset.pdpTab === name;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.pdpPanel !== name; });
    }
    tabs.forEach((tab, index) => {
      tab.id = 'PdpTab-' + root.dataset.sectionId + '-' + tab.dataset.pdpTab;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', tab.hash.slice(1));
      const panel = panels.find(p => p.dataset.pdpPanel === tab.dataset.pdpTab);
      panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', event => { event.preventDefault(); showPanel(tab.dataset.pdpTab); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); showPanel(tabs[next].dataset.pdpTab, true); }
      });
    });
    const requested = tabs.find(tab => tab.hash === location.hash);
    showPanel((requested || tabs[0]).dataset.pdpTab);
    root.querySelectorAll('[data-pdp-open]').forEach(link => link.addEventListener('click', () => showPanel(link.dataset.pdpOpen)));
    const description = root.querySelector('[data-pdp-description]');
    if (description) {
      description.querySelectorAll('img').forEach(img => {
        if (!img.getAttribute('src') && !img.getAttribute('srcset')) { img.remove(); return; }
        img.loading = 'lazy'; img.decoding = 'async';
      });
      [...description.querySelectorAll('p,div,span,ul,li')].reverse().forEach(el => {
        if (!el.textContent.trim() && !el.querySelector('img,video,iframe,table,svg')) el.remove();
      });
      const more = root.querySelector('[data-pdp-read-more]');
      if (description.scrollHeight > 520) { description.classList.add('is-collapsed'); more.hidden = false; }
      more?.addEventListener('click', () => { description.classList.remove('is-collapsed'); more.setAttribute('aria-expanded', 'true'); more.hidden = true; });
    }
    function parameterPairs(raw) {
      return raw.map(line => { const index = line.indexOf(': '); return index > 0 ? [line.slice(0,index).trim(), line.slice(index + 2).trim()] : null; }).filter(pair => pair && pair[0] && pair[1]);
    }
    function updateParameters(variant) {
      const rows = parameterPairs(variant.parameters ? variant.parameters.split(/\r?\n/) : data.baseParameters);
      const holder = root.querySelector('[data-pdp-parameter-table]');
      if (!holder) return;
      const table = document.createElement('table'); table.className = 'pdp-specifications';
      const tbody = document.createElement('tbody');
      rows.forEach(([label, value]) => {
        const tr = document.createElement('tr'), th = document.createElement('th'), td = document.createElement('td');
        th.scope = 'row'; th.textContent = label; td.textContent = value; tr.append(th,td); tbody.append(tr);
      });
      table.append(tbody); holder.replaceChildren(table);
      const tests = [/objem.*brutto|brutto.*objem|hrubý objem/,/objem|kapacita/,/teplotný rozsah|rozsah.*teplot|prevádzková teplota/,/príkon|výkon/,/rozmer|dĺžka/,/napájanie|napätie/,/materiál|konštrukcia/,/priemer/,/hmotnosť/];
      const iconNames = ['box','box','cold','plug','ruler','plug','shield','ruler','box'];
      const chosen = [];
      tests.forEach((test, priority) => {
        if (chosen.length >= 4 || (priority === 1 && chosen.some(item => /objem|kapacita/i.test(item.row[0])))) return;
        const row = rows.find(pair => !chosen.some(item => item.row === pair) && test.test(pair[0].toLowerCase()) && !(priority === 4 && /baleni|obal|vnútorn|kábl/i.test(pair[0])) && !(priority === 8 && /obal|brutto/i.test(pair[0])));
        if (row) chosen.push({row,icon:iconNames[priority]});
      });
      const facts = document.createElement('div'); facts.className = 'pdp-facts';
      chosen.forEach(({row:[label,value],icon}) => {
        const fact = document.createElement('div'); fact.className = 'pdp-fact';
        const reference = factIcons.querySelector('[data-icon="' + icon + '"] .icon');
        if (reference) fact.append(reference.cloneNode(true));
        const content = document.createElement('span'), strong = document.createElement('strong'), small = document.createElement('small');
        strong.textContent = value; small.textContent = label; content.append(strong,small); fact.append(content); facts.append(fact);
      });
      root.querySelector('.pdp-facts-holder').replaceChildren(...(chosen.length ? [facts] : []));
    }
    select.addEventListener('change', () => {
      const variant = data.variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      root.querySelector('[data-pdp-price]').textContent = variant.price;
      root.querySelector('[data-pdp-sticky-price]').textContent = variant.price;
      const compare = root.querySelector('[data-pdp-compare]'); compare.hidden = !variant.compare; compare.textContent = variant.compare || '';
      root.querySelector('[data-pdp-sku]').textContent = variant.sku || '';
      const stock = root.querySelector('[data-pdp-availability]'); stock.textContent = variant.availability; stock.classList.toggle('is-unavailable', !variant.available);
      button.disabled = !variant.available; button.querySelector('span').textContent = variant.available ? data.addLabel : data.unavailableLabel;
      input.min = variant.min || 1; input.step = variant.step || 1;
      if (variant.max) input.max = variant.max; else input.removeAttribute('max');
      quantity();
      root.dataset.productSku = variant.sku || '';
      root.dataset.variantKey = root.dataset.productKey + ':' + variant.id;
      root.dataset.productUrl = productUrl + '?variant=' + variant.id;
      root.dataset.productTitle = productTitle + (variant.title && variant.title !== 'Default Title' ? ' · ' + variant.title : '');
      showImage(variant.image, variant.fullImage, variant.imageAlt, variant.imageId);
      updateParameters(variant);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    });
    new MutationObserver(() => { stickyButton.disabled = button.disabled; }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
    new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 }).observe(root.querySelector('[data-pdp-buy-row]'));
  }
  function start() { document.querySelectorAll('[data-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pdp]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
